/**
 * ¿Puede este navegador hablar con una impresora Bluetooth?
 *
 * Safari en iOS NO implementa Web Bluetooth y no hay ajuste que lo active, así que
 * en el navegador de siempre esto devuelve `false` y la Barra no pinta nada de
 * impresión. Donde sí funciona (verificado 27-ago-2026 contra la Jolimark del club):
 *   - Bluefy en iPad — el navegador que usa la barra de CRUO
 *   - Chrome en Android
 *
 * Es una función y no una constante a propósito: en los tests se sustituye
 * `navigator.bluetooth` a mitad de un caso y una constante ya estaría congelada.
 */
export function haySoporteBLE() {
  return typeof navigator !== "undefined" && Boolean(navigator.bluetooth);
}
